// import { Injectable } from '@angular/core';
// import { ToastrService } from 'ngx-toastr';
// import { timeout } from 'rxjs';

// @Injectable({
//     providedIn: 'root', // This makes the service available throughout the app
//   })
// export class ToastService {
//     Toastoptions:any={
//         // timeOut:5000,
//         positionClass: 'toast-top-right',
//         closeButton:true
//     }
//   constructor(private toastr: ToastrService) {

//   }

//   showSuccess(message:string) {
//     this.toastr.success(message,'Success',this.Toastoptions);
//   }
//   showError(message:string){
//     this.toastr.error(message,'Error',this.Toastoptions)
//   }
//   showWarning(message:string){
//     this.toastr.warning(message,'Validation',this.Toastoptions)
//   }
//   showInfo(message:string){
//     this.toastr.info(message,'Validation')
//   }
// }

import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ValidationModalComponent } from '../shared/validation-modal/validation-modal.component';

@Injectable({
  providedIn: 'root', // This makes the service available throughout the app
})
export class ToastService {
  private defaultDuration = 5000; // Default duration for the snackbar

  constructor(private snackBar: MatSnackBar, private dialog: MatDialog) { }

  showSuccess(message: string) {
    this.openSnackBar(message, 'success', this.defaultDuration);
  }

  showError(message: string) {
    this.openSnackBar(message, 'error', this.defaultDuration);
  }

  showWarning(message: string) {
    this.openSnackBar(message, 'warning', this.defaultDuration);
  }

  showInfo(message: string) {
    this.openSnackBar(message, 'info', this.defaultDuration);
  }

  private openSnackBar(message: string, type: string, duration: number) {
    this.snackBar.open(message, 'X', {
      duration: duration,
      panelClass: [type],
      horizontalPosition: 'end',
      verticalPosition: 'top',
    });
    // this.dialog.open(ValidationModalComponent, {
    //   data: { message, type, duration },
    //   panelClass: 'custom-dialog-container', // Optional styling
    //   // position: { top: '0px', right: '0px' },
    //   hasBackdrop: false,
    //   disableClose: false
    // });
    // this.snackBar.openFromComponent(ValidationModalComponent, {
    //   duration: this.defaultDuration,
    //   horizontalPosition: 'end',
    //   verticalPosition: 'top',
    //   panelClass: type, // Apply CSS class for styling
    //   data: { message, type, duration, snackRef: this.snackBar }, // Pass data to component
    // });
  }

}
